module.exports = __webpack_public_path__ + "static/media/21ECLAC40.ab3e5c69.jpg";